var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:users-line",
    clipPath: "url(#clip0_21_199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.3194 31.2361C37.1944 31.2361 40.9861 27.2639 40.9861 22.3889C40.9861 17.5139 37.0138 13.7222 32.1388 13.7222C27.2638 13.7222 23.4722 17.6944 23.4722 22.3889C23.4722 27.2639 27.4444 31.2361 32.3194 31.2361ZM32.1388 17.3333C32.3194 17.3333 32.3194 17.3333 32.1388 17.3333C35.0277 17.3333 37.3749 19.6806 37.3749 22.5694C37.3749 25.4583 35.0277 27.625 32.1388 27.625C29.2499 27.625 27.0833 25.2778 27.0833 22.5694C27.0833 19.6806 29.4305 17.3333 32.1388 17.3333Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.0416 30.1528C55.611 27.0833 51.0971 25.4583 46.4027 25.6389H44.9583C44.5971 27.0833 44.0555 28.3472 43.3333 29.4306C44.4166 29.25 45.3194 29.25 46.4027 29.25C49.8333 29.0694 53.2638 30.1528 55.9721 32.1389V45.1389H59.5833V30.6944L59.0416 30.1528Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.2499 14.0833C43.1527 11.9167 45.6805 10.8333 48.0277 11.7361C50.1944 12.6389 51.2777 15.1667 50.3749 17.5139C49.6527 19.1389 48.0277 20.2222 46.4027 20.2222C46.0416 20.2222 45.4999 20.2222 45.1388 20.0417C45.3194 20.9444 45.3194 21.8472 45.3194 22.5694V23.6528C45.6805 23.6528 46.0416 23.8333 46.4027 23.8333C50.9166 23.8333 54.5277 20.2222 54.5277 15.8889C54.5277 11.375 50.9166 7.76389 46.5833 7.76389C43.6944 7.76389 41.1666 9.20833 39.7222 11.7361C40.6249 12.2778 41.5277 13 42.2499 14.0833Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.6666 29.6111C20.9444 28.5278 20.4027 27.2639 20.0416 25.8194H18.5972C13.9027 25.6389 9.38885 27.2639 5.95829 30.1528L5.41663 30.6944V45.1389H9.02774V32.1389C11.9166 30.1528 15.1666 29.0694 18.5972 29.25C19.6805 29.25 20.7638 29.4306 21.6666 29.6111Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.5972 23.6528C18.9583 23.6528 19.3194 23.6528 19.6806 23.4722V22.3889C19.6806 21.4861 19.6806 20.5833 19.8611 19.8611C19.5 20.0417 18.9583 20.0417 18.5972 20.0417C16.25 20.0417 14.2639 18.0556 14.2639 15.7083C14.2639 13.3611 16.25 11.375 18.5972 11.375C20.4028 11.375 22.0278 12.4583 22.75 14.0833C23.4722 13.1806 24.5556 12.2778 25.4583 11.5556C23.1111 7.76389 18.2361 6.5 14.4444 8.84722C10.6528 11.1944 9.38889 16.0694 11.7361 19.8611C13.1806 22.2083 15.7083 23.6528 18.5972 23.6528Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.125 40.9861L46.7639 40.4444C43.1528 36.4722 38.0972 34.125 32.6805 34.3056C27.2639 34.125 22.0278 36.4722 18.4167 40.4444L18.0555 40.9861V54.7083C18.0555 56.3333 19.3194 57.7778 21.125 57.7778H44.2361C45.8611 57.7778 47.3055 56.3333 47.3055 54.7083V40.9861H47.125ZM43.5139 54.1667H21.6667V42.25C24.5555 39.3611 28.5278 37.9167 32.6805 37.9167C36.6528 37.7361 40.625 39.3611 43.5139 42.25V54.1667Z",
    fill: "#FCB450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dd73ad578ee9c5164b6a868000001776.svg";
export { ForwardRef as ReactComponent };